import { debounce as _debounce } from 'lodash';

import { listKiosks } from './index';

export default _debounce(listKiosks, 350);
